import { PAGETITLE } from '@/store/types';

export default {
  methods: {
    setPageTitle(pageTitle) {
      this.$store.dispatch(PAGETITLE, pageTitle);
    },
  },
};
